/**
 * Features for product type smart.
 */
export enum LicenseParentsAppFeature {
  EDUCATIONAL_ACTIVITIES = 'educational_activities',
  COMMUNICATION = 'communication'
}
